var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTablet1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "121.277px",
    height: "195.931px",
    viewBox: "0 0 121.277 195.931",
    enableBackground: "new 0 0 121.277 195.931",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#C9C6C3",
    points: "115.163,150.89 118.721,145.691 86.425,9.663 79.582,2 55.496,48.255 66.991,99.162  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#E8E5DC",
    points: "79.582,2 115.163,150.89 29.221,193.314 3.495,76.171  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#54B3E5",
    points: "76.023,13.221 103.119,132.005 28.948,172.788 7.873,78.908  "
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#9B9D9D",
    cx: 63.296,
    cy: 164.713,
    rx: 6.158,
    ry: 6.979
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTablet1);
export default __webpack_public_path__ + "static/media/tablet1.09804be3b0c50676f2d30d398047ab46.svg";
export { ForwardRef as ReactComponent };